import { SelMessage } from "@selector/shared/components";
import { downloadPreparedFile } from "@selector/shared/jsx";
import { type FC } from "react";
import { ActionButton, ActionButtonIconPlacement, ActionButtonSize, notificationDismiss, VStack } from "widgets";

import type { FileDownloadEvent } from "@/modules/notifications/utils/types.ts";

export interface FileDownloadNotificationProps {
  downloadEvent: FileDownloadEvent;
}

export const FileDownloadNotification: FC<FileDownloadNotificationProps> = ({ downloadEvent }) => {
  const { fileName, fileKey } = downloadEvent;

  return (
    <VStack>
      <div>
        <SelMessage id={"websocket.file.exportReady"} values={{ filename: fileName }} />
      </div>
      <ActionButton
        icon={"download"}
        label={"Download"}
        size={ActionButtonSize.Small}
        iconPlacement={ActionButtonIconPlacement.Right}
        onPress={() => {
          downloadPreparedFile(fileKey);
          notificationDismiss(fileKey);
        }}
      />
    </VStack>
  );
};
